// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BackAndNeckAssessmentRouteImport } from './routes/back-and-neck-assessment'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as ClinicRecoveryPackagesRouteImport } from './routes/clinic-recovery-packages'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as MedicoLegalRouteImport } from './routes/medico-legal'
import { Route as OurHealthcareNetworkRouteImport } from './routes/our-healthcare-network'
import { Route as PhysioAtHomeRouteImport } from './routes/physio-at-home'
import { Route as SymptomGuideRouteImport } from './routes/symptom-guide'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ConsentTokenRouteImport } from './routes/consent.$token'
import { Route as ContractTokenRouteImport } from './routes/contract.$token'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopSlugRouteImport } from './routes/shop.$slug'
import { Route as ShopCheckoutRouteImport } from './routes/shop.checkout'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminActivityRouteImport } from './routes/_authenticated/admin/activity'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin/analytics'
import { Route as AuthenticatedAdminAssessmentsRouteImport } from './routes/_authenticated/admin/assessments'
import { Route as AuthenticatedAdminBookingsRouteImport } from './routes/_authenticated/admin/bookings'
import { Route as AuthenticatedAdminChatsRouteImport } from './routes/_authenticated/admin/chats'
import { Route as AuthenticatedAdminExerciseProgrammesRouteImport } from './routes/_authenticated/admin/exercise-programmes'
import { Route as AuthenticatedAdminInvoicesRouteImport } from './routes/_authenticated/admin/invoices'
import { Route as AuthenticatedAdminOrdersRouteImport } from './routes/_authenticated/admin/orders'
import { Route as AuthenticatedAdminPatientsRouteImport } from './routes/_authenticated/admin/patients'
import { Route as AuthenticatedAdminPaymentsRouteImport } from './routes/_authenticated/admin/payments'
import { Route as AuthenticatedAdminPayrollRouteImport } from './routes/_authenticated/admin/payroll'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin/reports'
import { Route as AuthenticatedAdminScheduleRouteImport } from './routes/_authenticated/admin/schedule'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as BlogCategorySlugRouteImport } from './routes/blog.category.$slug'
import { Route as ShopCategorySlugRouteImport } from './routes/shop.category.$slug'
import { Route as ShopOrderNumberRouteImport } from './routes/shop.order.$number'
import { Route as AuthenticatedAdminContractsIndexRouteImport } from './routes/_authenticated/admin/contracts.index'
import { Route as AuthenticatedAdminContractsIdRouteImport } from './routes/_authenticated/admin/contracts.$id'
import { Route as AuthenticatedAdminContractsNewRouteImport } from './routes/_authenticated/admin/contracts.new'
import { Route as AuthenticatedAdminContractsTemplatesRouteImport } from './routes/_authenticated/admin/contracts.templates'
import { Route as AuthenticatedAdminLettersIndexRouteImport } from './routes/_authenticated/admin/letters.index'
import { Route as AuthenticatedAdminLettersIdRouteImport } from './routes/_authenticated/admin/letters.$id'
import { Route as AuthenticatedAdminLettersNewRouteImport } from './routes/_authenticated/admin/letters.new'
import { Route as AuthenticatedAdminMedicalReportsIndexRouteImport } from './routes/_authenticated/admin/medical-reports.index'
import { Route as AuthenticatedAdminMedicalReportsIdRouteImport } from './routes/_authenticated/admin/medical-reports.$id'
import { Route as AuthenticatedAdminMedicalReportsNewRouteImport } from './routes/_authenticated/admin/medical-reports.new'
import { Route as AuthenticatedAdminProductsIndexRouteImport } from './routes/_authenticated/admin/products.index'
import { Route as AuthenticatedAdminProductsIdRouteImport } from './routes/_authenticated/admin/products.$id'
import { Route as AuthenticatedAdminReferralLettersIndexRouteImport } from './routes/_authenticated/admin/referral-letters.index'
import { Route as AuthenticatedAdminReferralLettersIdRouteImport } from './routes/_authenticated/admin/referral-letters.$id'
import { Route as AuthenticatedAdminReferralLettersNewRouteImport } from './routes/_authenticated/admin/referral-letters.new'
import { Route as AuthenticatedAdminSickNotesIndexRouteImport } from './routes/_authenticated/admin/sick-notes.index'
import { Route as AuthenticatedAdminSickNotesIdRouteImport } from './routes/_authenticated/admin/sick-notes.$id'
import { Route as AuthenticatedAdminSickNotesNewRouteImport } from './routes/_authenticated/admin/sick-notes.new'
import { Route as AuthenticatedAdminSickNotesPractitionerRouteImport } from './routes/_authenticated/admin/sick-notes.practitioner'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BackAndNeckAssessmentRoute = BackAndNeckAssessmentRouteImport.update({
            id: '/back-and-neck-assessment',path: '/back-and-neck-assessment',getParentRoute: () => rootRouteImport
          })
const BookingRoute = BookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => rootRouteImport
          })
const ClinicRecoveryPackagesRoute = ClinicRecoveryPackagesRouteImport.update({
            id: '/clinic-recovery-packages',path: '/clinic-recovery-packages',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const MedicoLegalRoute = MedicoLegalRouteImport.update({
            id: '/medico-legal',path: '/medico-legal',getParentRoute: () => rootRouteImport
          })
const OurHealthcareNetworkRoute = OurHealthcareNetworkRouteImport.update({
            id: '/our-healthcare-network',path: '/our-healthcare-network',getParentRoute: () => rootRouteImport
          })
const PhysioAtHomeRoute = PhysioAtHomeRouteImport.update({
            id: '/physio-at-home',path: '/physio-at-home',getParentRoute: () => rootRouteImport
          })
const SymptomGuideRoute = SymptomGuideRouteImport.update({
            id: '/symptom-guide',path: '/symptom-guide',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ConsentTokenRoute = ConsentTokenRouteImport.update({
            id: '/consent/$token',path: '/consent/$token',getParentRoute: () => rootRouteImport
          })
const ContractTokenRoute = ContractTokenRouteImport.update({
            id: '/contract/$token',path: '/contract/$token',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopSlugRoute = ShopSlugRouteImport.update({
            id: '/shop/$slug',path: '/shop/$slug',getParentRoute: () => rootRouteImport
          })
const ShopCheckoutRoute = ShopCheckoutRouteImport.update({
            id: '/shop/checkout',path: '/shop/checkout',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminActivityRoute = AuthenticatedAdminActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAssessmentsRoute = AuthenticatedAdminAssessmentsRouteImport.update({
            id: '/assessments',path: '/assessments',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBookingsRoute = AuthenticatedAdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminChatsRoute = AuthenticatedAdminChatsRouteImport.update({
            id: '/chats',path: '/chats',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminExerciseProgrammesRoute = AuthenticatedAdminExerciseProgrammesRouteImport.update({
            id: '/exercise-programmes',path: '/exercise-programmes',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminInvoicesRoute = AuthenticatedAdminInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminOrdersRoute = AuthenticatedAdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPatientsRoute = AuthenticatedAdminPatientsRouteImport.update({
            id: '/patients',path: '/patients',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPaymentsRoute = AuthenticatedAdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPayrollRoute = AuthenticatedAdminPayrollRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReportsRoute = AuthenticatedAdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminScheduleRoute = AuthenticatedAdminScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/blog/category/$slug',path: '/blog/category/$slug',getParentRoute: () => rootRouteImport
          })
const ShopCategorySlugRoute = ShopCategorySlugRouteImport.update({
            id: '/shop/category/$slug',path: '/shop/category/$slug',getParentRoute: () => rootRouteImport
          })
const ShopOrderNumberRoute = ShopOrderNumberRouteImport.update({
            id: '/shop/order/$number',path: '/shop/order/$number',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminContractsIndexRoute = AuthenticatedAdminContractsIndexRouteImport.update({
            id: '/contracts/',path: '/contracts/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminContractsIdRoute = AuthenticatedAdminContractsIdRouteImport.update({
            id: '/contracts/$id',path: '/contracts/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminContractsNewRoute = AuthenticatedAdminContractsNewRouteImport.update({
            id: '/contracts/new',path: '/contracts/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminContractsTemplatesRoute = AuthenticatedAdminContractsTemplatesRouteImport.update({
            id: '/contracts/templates',path: '/contracts/templates',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminLettersIndexRoute = AuthenticatedAdminLettersIndexRouteImport.update({
            id: '/letters/',path: '/letters/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminLettersIdRoute = AuthenticatedAdminLettersIdRouteImport.update({
            id: '/letters/$id',path: '/letters/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminLettersNewRoute = AuthenticatedAdminLettersNewRouteImport.update({
            id: '/letters/new',path: '/letters/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMedicalReportsIndexRoute = AuthenticatedAdminMedicalReportsIndexRouteImport.update({
            id: '/medical-reports/',path: '/medical-reports/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMedicalReportsIdRoute = AuthenticatedAdminMedicalReportsIdRouteImport.update({
            id: '/medical-reports/$id',path: '/medical-reports/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMedicalReportsNewRoute = AuthenticatedAdminMedicalReportsNewRouteImport.update({
            id: '/medical-reports/new',path: '/medical-reports/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProductsIndexRoute = AuthenticatedAdminProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProductsIdRoute = AuthenticatedAdminProductsIdRouteImport.update({
            id: '/products/$id',path: '/products/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReferralLettersIndexRoute = AuthenticatedAdminReferralLettersIndexRouteImport.update({
            id: '/referral-letters/',path: '/referral-letters/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReferralLettersIdRoute = AuthenticatedAdminReferralLettersIdRouteImport.update({
            id: '/referral-letters/$id',path: '/referral-letters/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReferralLettersNewRoute = AuthenticatedAdminReferralLettersNewRouteImport.update({
            id: '/referral-letters/new',path: '/referral-letters/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSickNotesIndexRoute = AuthenticatedAdminSickNotesIndexRouteImport.update({
            id: '/sick-notes/',path: '/sick-notes/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSickNotesIdRoute = AuthenticatedAdminSickNotesIdRouteImport.update({
            id: '/sick-notes/$id',path: '/sick-notes/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSickNotesNewRoute = AuthenticatedAdminSickNotesNewRouteImport.update({
            id: '/sick-notes/new',path: '/sick-notes/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSickNotesPractitionerRoute = AuthenticatedAdminSickNotesPractitionerRouteImport.update({
            id: '/sick-notes/practitioner',path: '/sick-notes/practitioner',getParentRoute: () => AuthenticatedAdminRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminActivityRoute: AuthenticatedAdminActivityRoute,AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminAssessmentsRoute: AuthenticatedAdminAssessmentsRoute,AuthenticatedAdminBookingsRoute: AuthenticatedAdminBookingsRoute,AuthenticatedAdminChatsRoute: AuthenticatedAdminChatsRoute,AuthenticatedAdminExerciseProgrammesRoute: AuthenticatedAdminExerciseProgrammesRoute,AuthenticatedAdminInvoicesRoute: AuthenticatedAdminInvoicesRoute,AuthenticatedAdminOrdersRoute: AuthenticatedAdminOrdersRoute,AuthenticatedAdminPatientsRoute: AuthenticatedAdminPatientsRoute,AuthenticatedAdminPaymentsRoute: AuthenticatedAdminPaymentsRoute,AuthenticatedAdminPayrollRoute: AuthenticatedAdminPayrollRoute,AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,AuthenticatedAdminScheduleRoute: AuthenticatedAdminScheduleRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminContractsIdRoute: AuthenticatedAdminContractsIdRoute,AuthenticatedAdminContractsNewRoute: AuthenticatedAdminContractsNewRoute,AuthenticatedAdminContractsTemplatesRoute: AuthenticatedAdminContractsTemplatesRoute,AuthenticatedAdminLettersIdRoute: AuthenticatedAdminLettersIdRoute,AuthenticatedAdminLettersNewRoute: AuthenticatedAdminLettersNewRoute,AuthenticatedAdminMedicalReportsIdRoute: AuthenticatedAdminMedicalReportsIdRoute,AuthenticatedAdminMedicalReportsNewRoute: AuthenticatedAdminMedicalReportsNewRoute,AuthenticatedAdminProductsIdRoute: AuthenticatedAdminProductsIdRoute,AuthenticatedAdminReferralLettersIdRoute: AuthenticatedAdminReferralLettersIdRoute,AuthenticatedAdminReferralLettersNewRoute: AuthenticatedAdminReferralLettersNewRoute,AuthenticatedAdminSickNotesIdRoute: AuthenticatedAdminSickNotesIdRoute,AuthenticatedAdminSickNotesNewRoute: AuthenticatedAdminSickNotesNewRoute,AuthenticatedAdminSickNotesPractitionerRoute: AuthenticatedAdminSickNotesPractitionerRoute,AuthenticatedAdminContractsIndexRoute: AuthenticatedAdminContractsIndexRoute,AuthenticatedAdminLettersIndexRoute: AuthenticatedAdminLettersIndexRoute,AuthenticatedAdminMedicalReportsIndexRoute: AuthenticatedAdminMedicalReportsIndexRoute,AuthenticatedAdminProductsIndexRoute: AuthenticatedAdminProductsIndexRoute,AuthenticatedAdminReferralLettersIndexRoute: AuthenticatedAdminReferralLettersIndexRoute,AuthenticatedAdminSickNotesIndexRoute: AuthenticatedAdminSickNotesIndexRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,BackAndNeckAssessmentRoute: BackAndNeckAssessmentRoute,BookingRoute: BookingRoute,ClinicRecoveryPackagesRoute: ClinicRecoveryPackagesRoute,ContactRoute: ContactRoute,FaqsRoute: FaqsRoute,MedicoLegalRoute: MedicoLegalRoute,OurHealthcareNetworkRoute: OurHealthcareNetworkRoute,PhysioAtHomeRoute: PhysioAtHomeRoute,SymptomGuideRoute: SymptomGuideRoute,TestimonialsRoute: TestimonialsRoute,BlogSlugRoute: BlogSlugRoute,ConsentTokenRoute: ConsentTokenRoute,ContractTokenRoute: ContractTokenRoute,ServicesSlugRoute: ServicesSlugRoute,ShopSlugRoute: ShopSlugRoute,ShopCheckoutRoute: ShopCheckoutRoute,BlogIndexRoute: BlogIndexRoute,ServicesIndexRoute: ServicesIndexRoute,ShopIndexRoute: ShopIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,BlogCategorySlugRoute: BlogCategorySlugRoute,ShopCategorySlugRoute: ShopCategorySlugRoute,ShopOrderNumberRoute: ShopOrderNumberRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)